import { ShareButtons } from 'shared'

export const SharingContainer = (props) => {
  return <div className="projects-show-sharing" id="share">
    <div className="container">
      <div className="row">
        <div className="col-md-24 text-center">
          <h1>{I18n.t('projects.show.sharing.headline')}</h1>
          <div className="row">
            <div className="col-md-6 offset-md-9">
              <ShareButtons
                platforms={['facebook', 'twitter', 'email', 'whatsapp', 'messenger']}
                mobileOnly={['whatsapp', 'messenger']}
                shape='round'
                shareUrl={props.shareUrl}
                gaLabel='ppp_sharing_module'
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
